<form [formGroup]="findTripFormGroup" (ngSubmit)="onSubmit()" #myForm="ngForm">
  <p class="form-title">{{ formsMetadata.title }}</p>
  <tic-auto-complete-form-field [optionsFormControl]="originLocationCodeFormControl"
    [fieldName]="formsMetadata['origin'].fieldName" [optionsArray]="formsMetadata['origin'].optionsArray"
    [validatorFunction]="isValueInArrayValidator">
  </tic-auto-complete-form-field>
  <tic-auto-complete-form-field [optionsFormControl]="destinationLocationCodeFormControl"
    [fieldName]="formsMetadata['destination'].fieldName" [optionsArray]="formsMetadata['destination'].optionsArray"
    [validatorFunction]="isValueInArrayValidator">
  </tic-auto-complete-form-field>
  <tic-adults-children-age [numberOfAdultsFormControl]="numberOfAdultsFormControl"
    [numberOfChildrenFormControl]="numberOfChildrenFormControl"
    [paxesChildrenAgesFormControl]="paxesChildrenAgesFormControl">
  </tic-adults-children-age>
  <tic-auto-complete-form-field [optionsFormControl]="numberOfRoomsFormControl"
    [fieldName]="formsMetadata['numberOfRooms'].fieldName" [optionsArray]="formsMetadata['numberOfRooms'].optionsArray"
    [validatorFunction]="isValueInArrayValidator">
  </tic-auto-complete-form-field>
  <tic-date-range [datesFormGroup]="datesFormGroup"></tic-date-range>
  <tic-button class="tic-button" [buttonText]="formsMetadata['submitButton']">
  </tic-button>
</form>